import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  ETimeBucketType,
  EReportingTimeWindow,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { coreAPI } from '../services/coreAPI'
import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDOOHLocationsReportChartFilters,
  TPPAdvertiserId,
} from '../models/types'
import { IDOOHReportingLocationsChartResponse } from '../models'

export default function useGetAdvertiserReportingDOOHLocationsChartV3({
  advertiserId,
  retailerId,
  campaignId,
  adGroupId,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & TDOOHLocationsReportChartFilters &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IDOOHReportingLocationsChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingDOOHLocationsChart_${advertiserId}_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate }],
    () => {
      return coreAPI
        .v2AdvertiserReporting()
        .getDOOHAdvertiserLocationsReportChart(
          advertiserId,
          generateCorrelationId(),
          retailerId,
          campaignId,
          adGroupId,
          timeWindow as unknown as EReportingTimeWindow,
          startDate,
          endDate,
          tzZone || getTimezone(),
          aggregationType as ETimeBucketType,
          filterBy,
          filterOperation,
          filterValue,
          name,
          // @ts-expect-error: fix in PORT-2535
          status
        )
    },
    { suspense, enabled }
  )
}
